import { LANGUAGES } from '../constants/lang';

export class Slot {
  uuid_event_occurrence: string;
  occurrence_start_time: string;
  occurrence_end_time: string;
  available_users: number;
  are_reservations_open: boolean;
  are_reservations_not_closed: boolean;
  are_reservations_not_closed_wl: boolean;
  at_least_one_can_reserve: boolean;
  ticketDateTime: string;
  ticket_file_name: string;
  max_users: number;
  available_users_wl: number;
  max_users_wl: number;
  detail: string;

  selected: boolean;
  available: boolean;
  displayDateTime: string;

  constructor(
    uuid: string,
    start_time: string,
    end_time: string,
    ticket_datetime: string,
    ticket_file_name: string,
    available_users: number,
    max_users: number,
    are_reservations_open: boolean,
    are_reservations_not_closed: boolean,
    are_reservations_not_closed_wl: boolean,
    at_least_one_can_reserve: boolean,
    available_users_wl: number,
    max_users_wl: number,
    selected_date: Date,
    detail: string
  ) {
    this.uuid_event_occurrence = uuid;
    this.occurrence_start_time = start_time;
    this.occurrence_end_time = end_time;
    this.available_users = available_users;
    this.max_users = max_users;
    this.available_users_wl = available_users_wl;
    this.max_users_wl = max_users_wl;

    this.are_reservations_open = are_reservations_open;
    this.are_reservations_not_closed = are_reservations_not_closed;
    this.are_reservations_not_closed_wl = are_reservations_not_closed_wl;
    this.at_least_one_can_reserve = at_least_one_can_reserve;
    this.selected = false;
    this.available =
      (this.available_users > 0 || this.available_users_wl > 0) &&
      this.are_reservations_open &&
      this.at_least_one_can_reserve;
    this.displayDateTime = this.getFormattedDateTime(selected_date);
    this.ticketDateTime = ticket_datetime;
    this.ticket_file_name = ticket_file_name;
    this.detail = detail || '';
  }

  private getFormattedDateTime(inputDate: Date): string {
    if (!inputDate || !this.occurrence_start_time) return '';

    return `${inputDate.getDate()}/${
      inputDate.getMonth() + 1
    }/${inputDate.getFullYear()}`;
  }

  static convertTime(time: any, userLanguage: string) {
    if (!time || userLanguage == LANGUAGES.it) {
      return time;
    }

    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join('');
  }
}
